import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { DeckLayoutContextValue } from "#deck-layout-context-value";

export const DeckLayoutContext = createContext(
  defaultError<DeckLayoutContextValue>("DeckLayoutContext"),
);
